import React from 'react'
import { BackgroundColors } from 'types/contentful'
import topRightBadge from '../../../images/badge-nominerad-arets-byra-2025-negative-white.svg'
import './hero.scss'

interface Props {
  title: string
  children: React.ReactNode | React.ReactNode[]
  imageUrl?: string
  videoUrl?: string
  background: BackgroundColors | undefined
  isFullScreenHero: boolean | undefined
}

export const Hero: React.FC<Props> = ({
  title,
  children,
  imageUrl,
  videoUrl,
  isFullScreenHero,
  background,
}) => {
  const style = {
    backgroundColor: background,
  }

  const titleStyle =
    background == '#313341' ? 'hero__title hero--white' : 'hero__title'
  const textStyle =
    background == '#313341' ? 'hero__text hero--white' : 'hero__text'
  const headerStyle =
    background == '#313341'
      ? 'block block--hero hero header-light'
      : 'block block--hero hero header-dark'
  const fullScreenHero = !isFullScreenHero ? 'hero__image' : 'hero__image-full'

  const contentClass = isFullScreenHero
    ? 'hero__content hero__content--new'
    : 'hero__content hero__content--old'

  const badgeClass = isFullScreenHero
    ? 'hero__top-right-badge hero__top-right-badge--new'
    : 'hero__top-right-badge hero__top-right-badge--old'

  return (
    <div className={headerStyle} style={style}>
      {videoUrl ? (
        <video
          className={fullScreenHero}
          src={videoUrl}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          disableRemotePlayback
          controls={false}
        />
      ) : imageUrl ? (
        <img src={imageUrl} className={fullScreenHero} alt="" />
      ) : null}

      <img className={badgeClass} src={topRightBadge} alt="" />

      <div className={contentClass}>
        <h1 className={titleStyle}>{title}</h1>
        <div className={textStyle}>{children}</div>
      </div>
    </div>
  )
}
